var addToFavourites = {
    init: function () {
        // const favoriteBtns = document.querySelectorAll("[data-favoriteid]");
        // if (favoriteBtns) {
        //     const addedDocuments = JSON.parse(sessionStorage.vuex).addedDocuments;
        //     favoriteBtns.forEach(function (btn) {
        //         const btnFaveId = btn.dataset.favoriteid;
        //         btn.addEventListener("click", function () {
        //             console.log("favorite button clicked")
        //             const favoriteId = document.getElementById("favoriteId");
        //             favoriteId.value = btnFaveId;
        //             var change = new Event('change');
        //             favoriteId.dispatchEvent(change);
        //         })
        //         if(addedDocuments.includes(parseInt(btnFaveId))) btn.classList.add('in-list');
        //     }
        //     );
        // }
        // document.addEventListener('click', function(event) {
        //     console.log("Clicked ", event);
        //     if(event.target.classList.contains("add-favorite")) {
        //         console.log("Add to fAVORiTe");
        //     }
        // })
    }
}

export default addToFavourites;